import { Component, Input, ViewChild, TemplateRef } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { FeatherIconsComponent } from "../../feather-icons/feather-icons.component";
import { Subscription } from "rxjs";
import { UserSession } from "../../../../models/user.model";

import { UserService } from "../../../services/users/user.service";
import { AuthService } from "../../../services/users/auth.service";
import { localStorageConstants } from "../../../../consts/local_storage_constants";
import Swal from "sweetalert2";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SuperadminModelComponent } from "../../../../superadmin/superadmin-list/superadmin-model/superadmin-model.component";
import { SuperadminEditRequest } from "../../../../models/superadmin.model";
import { jwtDecode } from "jwt-decode";
import { SuperAdminUserActivityService } from "../../../services/superadminusers/superadmin-user-activity.service";
import { EventEmitterService } from "../../../services/users/event-emitter.service";
import { SharedModule } from "../../../shared.module";
import { CompanyService } from "../../../services/company/company.services";
import { showNotification } from "../../../../consts/utils";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoaderComponent } from "../../loader/loader.component";

@Component({
  selector: "app-profile",
  imports: [FeatherIconsComponent, RouterModule, SharedModule, LoaderComponent],
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"]
})

export class ProfileComponent {

  user: any = '';
  role: any = '';
  portalProfile: any = '';
  superadminData: any = {};
  @Input() userSession: UserSession;
  isLoading = false;
  userType: any = '';

  public isShow: boolean = false;
  private eventSubscription: Subscription;
  tokenInfo: any;
  isFirstLogin: any

  @ViewChild('cancelSubscriptionModal') cancelSubscriptionModal!: TemplateRef<any>;
  modalRef!: NgbModalRef;

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }

  constructor(private _authService: AuthService, private _modal: NgbModal, private companyService: CompanyService,
    private _userService: UserService, private router: Router, private userActivityService: SuperAdminUserActivityService,
    private _eventEmitterService: EventEmitterService, private snackBar: MatSnackBar) {

    this.userType = localStorage.getItem(localStorageConstants.USER_TYPE);
    const portalLoggedIn = localStorage.getItem(localStorageConstants.PORTAL_LOGGED_IN);
    const superAdminLoggedIn = localStorage.getItem(localStorageConstants.SUPER_ADMIN_LOGGED_IN);

    if (portalLoggedIn || superAdminLoggedIn) {
      if (this.userType == 'super-admin') {
        const storedData = localStorage.getItem(localStorageConstants.SUPER_ADMIN_DATA);
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          this.superadminData = parsedData;
          this.user = parsedData.firstName + " " + parsedData.lastName;
        }
      } else {
        // Portal name Here
        const token: any = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
        this.tokenInfo = this.getDecodedAccessToken(token); // decode token
        this.user = this.tokenInfo.firstName + " " + this.tokenInfo.lastName;
        this.role = this.tokenInfo.role.toLocaleUpperCase();
        this.portalProfile = this.tokenInfo.profilePicture;
        this.isFirstLogin = this.tokenInfo.isFirstLogin;
      }
    }
  }

  ngOnInit(): void {
    this.eventSubscription = this._eventEmitterService.event$.subscribe((event) => {
      if (event.event === "updateUser") {
        // Update the profile picture directly
        this.portalProfile = event.data.profilePicture;

        // Also update userSession if needed
        if (this.userSession) {
          this.userSession.profilePicture = event.data.profilePicture;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  updateUser() {
    this._userService.getProfile(this.userSession.id).subscribe({
      next: (res) => {
        this.userSession = res; // Update the entire session
        this.user = `${res.firstName} ${res.lastName}`;
        this.role = res.role?.toUpperCase();
        this.portalProfile = res.profilePicture;

        // Reload token data (if necessary)
        const token = localStorage.getItem(localStorageConstants.PORTAL_TOKEN);
        if (token) {
          this.tokenInfo = this.getDecodedAccessToken(token);
        }
      }
    });
  }

  logOut() {
    Swal.fire({
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.userType == 'super-admin') {
          this.userActivityService.trackUserActivity(this.superadminData, false);
          this._authService.logOut();
        } else {
          this._authService.portalLogOut();
        }
      }
    });
  }

  openUserProfile() {
    this.router.navigate(['/portal/profile']);
  }

  editSuperadmin() {
    var superadmin: SuperadminEditRequest = {
      _id: this.superadminData._id,
      email: this.superadminData.email,
      firstName: this.superadminData.firstName,
      middleName: this.superadminData.middleName,
      lastName: this.superadminData.lastName,
      phone: this.superadminData.phone,
    };
    let modalRef: NgbModalRef = this._modal.open(SuperadminModelComponent, { centered: true, backdrop: 'static', });
    modalRef.componentInstance.user = superadmin;
    // modalRef.componentInstance.refreshTable = this.refreshTable;
  }

  openModal() {
    this.modalRef = this._modal.open(this.cancelSubscriptionModal, {
      backdrop: 'static',
      centered: true
    });

    this.modalRef.result.then(
      result => console.log('Closed with:', result),
      reason => console.log('Dismissed with:', reason)
    );
  }

  closeModal() {
    this.modalRef.close('Closed by button');
  }


  confirmCancelSubscription(modal: NgbModalRef) {
    this.isLoading = true;
    // Call your cancellation logic here (e.g. API call)
    this.companyService.cancelFreePlan().subscribe({
      next: (res) => {
        this.isLoading = false;
        showNotification(this.snackBar, res.message, 'success');
        console.log('Subscription cancelled');
        this._authService.portalLogOut();
        modal.close('cancelled');
      },
      error: (error) => {
        this.isLoading = false;
        showNotification(this.snackBar, error.message, 'success');
      }
    })

  }
}



